<template>
  <div class="my-area" data-automation="myArea">
    <el-select
      v-model="formValidate[0]"
      :size="size"
      :clearable="clearable"
      :popper-append-to-body="appendBody"
      :placeholder="$t('HT.province')"
      @change="change"
      @clear="clearArea"
    >
      <el-option
        v-for="(item, index) in arr"
        :label="item.name"
        :value="item.name"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      v-if="!province"
      v-model="formValidate[1]"
      :size="size"
      :clearable="clearable"
      :popper-append-to-body="appendBody"
      :placeholder="$t('HT.city')"
      @change="cityChange"
    >
      <el-option
        v-for="(item, index) in cityArr"
        :label="item.name"
        :value="item.name"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      v-if="!province"
      v-model="formValidate[2]"
      :size="size"
      :clearable="clearable"
      :popper-append-to-body="appendBody"
      :placeholder="$t('HT.counties')"
      @clear="clearCounty"
    >
      <el-option
        v-for="(item, index) in districtArr"
        :label="item.name"
        :value="item.name"
        :key="index"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import city from './city2.js';
import i18n from '@/i18n/index.js';

export default {
  name: 'MyArea',
  model: {
    prop: 'area', // 要存在于proops
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    area: {
      // 三级地区数组
      type: Array,
      default: () => {
        return [];
      }
    },
    placeholder: {
      // 占位符
      type: String,
      default: () => i18n.t('HT.pleaseSelect')
    },
    province: {
      // 只显示省
      type: Boolean,
      default: false
    },
    size: {
      // 大小
      type: String,
      default: 'small'
    },
    appendBody: {
      // 下拉框是否添加在body
      type: Boolean,
      default: false
    },
    clearable: {
      // 是否可清除
      type: Boolean,
      default: false
    },
    autoChoice: {
      // 是否自动选择下一级第一个
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      formValidate: this.area,
      arr: city.arrAll, // 空数组，用于存储所有省
      cityArr: [], // 空数组，用于存储所有市
      districtArr: [] // 空数组，用于存储所有区
    };
  },

  created() {
    this.initCity();
  },

  methods: {
    /**
     * 获取数据，初始化省市区三级联动
     */
    initCity() {
      for (let i in this.arr) {
        let obj = this.arr[i];
        if (obj.name == this.formValidate[0]) {
          this.cityArr = obj.sub || [];
          break;
        }
      }

      for (let i in this.cityArr) {
        let obj = this.cityArr[i];
        if (obj.name == this.formValidate[1]) {
          this.districtArr = obj.sub || [];
          break;
        }
      }
    },

    /**
     * 三级联动改变
     */
    change() {
      if (this.formValidate[0]) {
        for (let i in this.arr) {
          let obj = this.arr[i];
          if (obj.name == this.formValidate[0]) {
            this.cityArr = obj.sub || [];
            break;
          }
        }

        if (this.cityArr.length > 0 && this.autoChoice) {
          this.formValidate[1] = this.cityArr[0].name;
        } else {
          this.formValidate.splice(1, 2);
        }

        for (let i in this.cityArr) {
          let obj = this.cityArr[i];
          if (obj.name == this.formValidate[1]) {
            this.districtArr = obj.sub || [];
            break;
          }
        }

        if (this.districtArr.length > 0 && this.autoChoice) {
          this.formValidate[2] = this.districtArr[0].name;
        } else {
          this.formValidate.splice(2, 1);
        }
      } else {
        this.formValidate.splice(0, 3);
        this.cityArr = [];
        this.districtArr = [];
      }
    },

    /**
     * 城市改变
     */
    cityChange() {
      if (this.formValidate[1]) {
        for (let i in this.cityArr) {
          let obj = this.cityArr[i];
          if (obj.name == this.formValidate[1]) {
            this.districtArr = obj.sub || [];
            break;
          }
        }

        if (this.districtArr.length > 0 && this.autoChoice) {
          this.formValidate[2] = this.districtArr[0].name;
        } else {
          this.formValidate.splice(2, 1);
        }
      } else {
        this.formValidate.splice(1, 2);
        this.districtArr = [];
      }
    },

    /**
     * 县区改变
     */
    clearCounty() {
      this.formValidate.splice(2, 1);
    },

    clearArea() {
      this.$emit('clearArea');
    },

    /**
     * 删除数组空字符串
     * @param {Array} arr 数组
     */
    deleteEmpty(arr) {
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]) {
          res.push(arr[i]);
        }
      }
      return res;
    }
  },

  watch: {
    // 这里检测data中的值，一旦发生变化就提交事件到父组件
    formValidate: {
      handler(newVal) {
        this.$emit('change', newVal);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.my-area {
  width: 100%;
  display: flex;

  .el-select {
    flex: 1;
    width: auto;
    min-width: 90px;
    margin-right: 15px;
  }

  .el-select:last-child {
    margin-right: 0;
  }
}
</style>
